export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}

export function formatViewers(value: number): string {
  if (value >= 100000000) {
    return `${(value / 100000000).toFixed(1)} 亿`;
  }
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return String(value);
}

export function formatLikes(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return String(value);
}

export function padIndex(value: number): string {
  return value < 10 ? `0${value}` : String(value);
}